import React, { Fragment } from "react";
import Navbar from "../components/header/header.component.js";
import Footer from "../components/Footer/Footer.component.js";
import TablemenuComponent from "../components/Tablemenu/Tablemenu.component.js";
import tt01 from "../images/tt01.jpg";
import tt02 from "../images/tt02.jpg";
import tt03 from "../images/tt03.jpg";
import tt04 from "../images/tt04.jpg";
import { Helmet } from "react-helmet";

const Leandermenu = () => {
  return (
    <Fragment>

      <Helmet>
        <title>Tablemenu | Taco Twist</title>
        <meta name="description" content="Discover the nearest taco place with Taco Twist! Indulge in flavorful delights at tacotwist.com. Explore our menu for a tasty taco experience right around the corner!
" />


      </Helmet>

      <Navbar />
      <hr/>
      <div className="container">
        <h1 className="text-3xl font-bold mb-6 text-center">Leander Taco Menu</h1>
      <div>
      <img src={tt01} alt="Menu Image" />
      </div>
      <br></br>
      <br></br>
     
      <div>
      <img src={tt02} alt="Menu Image" />
      </div>
      <br></br>
      <br></br>
      
      <div>
      <img src={tt03} alt="Menu Image" />
      </div>
       <br></br>
      <br></br>

      <div>
      <img src={tt04} alt="Menu Image" />
      </div>
      <br></br>
      <br></br>
      
      </div>
      <br></br>
      <br></br>
      {/* <TablemenuComponent /> */}
      <Footer />
    </Fragment>
  );
};

export default Leandermenu;
